<template>
  <div>
    <picture v-if="filename !== 'spread8_b2'">
        <source media="(min-width: 1350px)" :srcset="`/img/${filename}-1840.${extension}`">
        <source media="(min-width: 900px)" :srcset="`/img/${filename}-1680.${extension}`">
        <source media="(min-width: 450px)" :srcset="`/img/${filename}-1200.${extension} 1x, /img/${filename}-1680.${extension} 2x, /img/${filename}-1680.${extension} 3x`">
        <source media="(max-width: 450px)" :srcset="`/img/${filename}-900.${extension} 1x, /img/${filename}-1200.${extension} 2x, /img/${filename}-1200.${extension} 3x`">
        <img :src="`/img/${filename}-900.${extension}`" alt="">
    </picture>

    <img v-else :src="`/assets/${filename}.${extension}`" alt="">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import objectFitImages from 'object-fit-images'

export default {
  name: 'Img',
  props: ['src', 'filename'],

  mounted () {
    objectFitImages()
  },

  computed: mapState({
    webP: state => state.webp,
    extension () {
      return this.webP ? 'webp' : 'png'
    }
  })
}
</script>
